<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <div class="uploading" v-if="uploading"></div>
        <h4>Ganti Latar Belakang</h4>
        <div class="bgCnt">
          <div class="bgItem bg1"
            :class="{selected: selectedBg === 'bg1'}"
            v-on:click="selectBg('bg1')"></div>
          <div class="bgItem bg2"
            :class="{selected: selectedBg === 'bg2'}"
            v-on:click="selectBg('bg2')">
          </div>
          <div class="bgItem bg3"
            :class="{selected: selectedBg === 'bg3'}"
            v-on:click="selectBg('bg3')">
          </div>
          <div class="bgItem bg4"
            :class="{selected: selectedBg === 'bg4', disabled: point < 1240}"
            v-on:click="selectBg('bg4')">
            <span v-if="point < 1240">Terbuka<br/>di 1.240pt</span>
          </div>
        </div>
        <div class="customBg" v-on:click="setCustomBg">Pilih Gambar</div>
      </div>
      <input type="file" ref="file"
        accept="image/png,image/x-png,image/jpeg,image/jpg"
        v-on:change="handleFile"
        style="display: none">
      <Confirmation ref="confirmDialog"/>
    </div>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'changeBg',
  components: { Confirmation },
  data() {
    return {
      show: false,
      next: null,
      point: 0,
      selectedBg: 'bg1',
      customBg: null,
      uploading: false,
    };
  },
  methods: {
    open(d, next) {
      this.next = next;
      this.show = true;
      this.point = this.$session.get('bk6_point') || 0;
      this.selectedBg = this.$session.get('bk6_bg') || 'bg1';
    },
    setCustomBg() {
      this.$refs.file.click();
    },
    handleFile() {
      const [file] = this.$refs.file.files;
      if (!file) return;
      this.uploading = true;
      const formData = new FormData();
      formData.append('image', file);
      this.$http.post(this.$config.uri('user/custombg'), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          // Display progress in chat
        },
      }).then((r) => {
        this.uploading = false;
        if (r.data.status !== 200) {
          return;
        }
        this.selectedBg = 'custom';
        this.customBg = r.data.uri;
        this.$session.set('bk6_bg', 'custom');
        this.$session.set('bk6_customBg', r.data.uri);
        this.close(true);
      });
    },
    selectBg(bg) {
      if (bg === 'bg4' && this.point < 1240) return;
      if (this.selectedBg !== 'bg4' && bg === 'bg4') {
        this.$refs.confirmDialog.open({
          title: 'Ganti Latar Belakang',
          desc: 'Latar belakang luar angkasa hanya bisa digunakan dengan baju Astronot',
          action: 'Lanjutkan',
        }, (b) => {
          if (!b) return;
          this.selectedBg = bg;
          this.$session.set('bk6_bg', bg);
          this.$http.post(this.$config.uri('user/set/bg'), { bg }).then(() => {});
          this.$session.set('bk6_accTop', 'astro');
          this.$session.set('bk6_accMid', 'none');
          this.$session.set('bk6_accBot', 'none');
          this.$http.post(this.$config.uri('user/set/acc'), {
            accTop: 'astro',
            accMid: 'none',
            accBot: 'none',
          }).then(() => {});
          this.close(true);
        });
        return;
      }
      this.selectedBg = bg;
      this.$session.set('bk6_bg', bg);
      this.$http.post(this.$config.uri('user/set/bg'), { bg }).then((r) => {});
      this.close(true);
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, this.selectedBg, this.customBg);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 60px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 520px;
      .uploading{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        background-color: #fff;
        background-size: 46px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/loading.svg);
        z-index: 9;
      }
      .close{
        width: 36px; height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/close.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .7;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: rgba(0,0,0,.2);
          opacity: .6;
        }
      }
      @media (max-width: 680px) {
        width: calc(100% - 20px);
        box-sizing: border-box;
        padding: 30px 30px;
      }
      &.hasCheck{
        text-align: left;
      }
      h4{
        margin: 0;
        font-size: 24px;
        margin-bottom: 16px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #006519;
        font-weight: bold;
        font-size: 22px;
      }
      .bgCnt{
        display: flex;
        justify-content: space-between;
        .bgItem{
          background-color: #ccc;
          height: 160px;
          width: calc(25% - 10px);
          border-radius: 10px;
          background-position: center;
          background-size: cover;
          box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
          position: relative;
          cursor: pointer;
          transition: all .3s ease;
          @media (max-width: 520px) {
            height: 100px;
            border-radius: 5px;
            width: calc(25% - 6px);
          }
          &:hover{
            box-shadow: 2px 2px 8px rgba(0, 0, 0, .3);
            &:before{
              content: "";
              position: absolute;
              left: -2px; right: -2px; top: -2px; bottom: -2px;
              border-radius: 12px;
              border: #ccc 2px solid;;
              box-sizing: border-box;
            }
          }
          span{
            display: none;
          }
          &:active{
            box-shadow: none;
          }
          &.bg1{
            background-image: url(../assets/bg-1.jpg);
          }
          &.bg2{
            background-image: url(../assets/bg-2.jpg);
          }
          &.bg3{
            background-image: url(../assets/bg-3.jpg);
          }
          &.bg4{
            background-image: url(../assets/bg-4.jpg);
          }
          &.selected{
            &:before{
              content: "";
              position: absolute;
              left: -2px; right: -2px; top: -2px; bottom: -2px;
              border-radius: 12px;
              border: #78C90E 2px solid;;
              box-sizing: border-box;
            }
          }
          &.disabled{
            box-shadow: none;
            filter: grayscale(1);
            span{
              border-radius: 10px;
              display: flex;
              position: absolute;
              left: 0; right: 0; top: 0; bottom: 0;
              background-color: rgba(0, 0, 0, .7);
              color: #ddd;
              font-size: 13px;
              display: flex;
              justify-content: center;
              text-align: center;
              align-items: center;
            }
          }
        }
      }
      .customBg{
        background-color: #78C90E;
        color: #fff;
        padding: 14px 20px;
        text-align: center;
        font-size: 18px;
        border-radius: 5px;
        margin-top: 16px;
        transition: all .3s ease;
        cursor: pointer;
        &:hover{
          background-color: #006519;
        }
        &.disabled{
          background-color: #ddd !important;
          color: #999 !important;
          padding: 10px 20px;
        }
        p{
          font-size: 13px;
          margin: 0;
        }
      }
    }
  }
</style>
